'use client'

import { useRouter } from 'next/navigation'
import { Order, Listing, useAddItemMutation } from '@/api'
import { Button } from '@/components/ui/button'
import { PlusIcon } from 'lucide-react'
import { useGTMTracking } from '@/hooks/useGTMTracking'
import { useCurrentUserQuery, User } from '@/api'

interface AddToBagButtonProps {
  listing?: Listing | null
  currentOrder?: Order | null
  onSoldOut: () => void
  className?: string
}

export const AddToBagButton = ({
  listing,
  currentOrder,
  onSoldOut,
  className = '',
}: AddToBagButtonProps) => {
  const router = useRouter()
  const { trackEvent } = useGTMTracking()
  const { data: { currentUser } = {} } = useCurrentUserQuery({
    fetchPolicy: 'cache-and-network',
  })

  const [addItem, { loading }] = useAddItemMutation({
    onCompleted: (data) => {
      if (data.addItem.error) {
        onSoldOut()
      } else {
        if (listing) {
          trackEvent(
            'add_to_cart',
            listing.product,
            currentUser as User,
            null,
            listing
          )
        }
        router.push('/cart')
      }
    },
  })

  const handleAddItem = () => {
    if (!listing || !currentOrder) {
      return
    }

    addItem({
      variables: {
        orderUuid: currentOrder.uuid,
        listingUuid: listing.uuid,
      },
    })
  }

  if (listing?.isSoldOut) {
    return (
      <Button
        className={`px-20 py-4 w-full h-auto flex items-center gap-5 bg-[#8C8C8C] text-white rounded-none text-sm lg:text-base cursor-auto ${className}`}
        disabled
      >
        売り切れました
      </Button>
    )
  }

  return (
    <Button
      className={`px-20 py-4 w-full h-auto flex items-center gap-5 bg-primary text-white rounded-none text-sm lg:text-base ${className}`}
      onClick={handleAddItem}
      disabled={loading}
    >
      <PlusIcon color="#EFEFEF" />
      {loading ? 'Adding...' : 'カートに入れる'}
    </Button>
  )
}
